"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHappyResponse = exports.isHttpCodeOkOrCreated = void 0;
function isHttpCodeOkOrCreated(code) {
    return [200, 201].includes(code);
}
exports.isHttpCodeOkOrCreated = isHttpCodeOkOrCreated;
function isHappyResponse(response) {
    return response && response.data && isHttpCodeOkOrCreated(response.status);
}
exports.isHappyResponse = isHappyResponse;
//# sourceMappingURL=common.js.map